import React from 'react';
import { styled as muiStyled } from '@mui/system';
import styled from 'styled-components';

// oxlint-disable-next-line no-restricted-imports
import MaterialUIButton from '@mui/material/Button';

import MuiIconButton from '@mui/material/IconButton';

import { colors } from '../../theme/colors';

export const Button = muiStyled(MaterialUIButton)`
  border-radius: 5px;
  font-style: normal;
  letter-spacing: 0.46px;
  text-transform: initial;
  white-space: nowrap;

  &.MuiButton-sizeLarge {
    font-size: 15px;
    height: 42px;
  }

  &.MuiButton-sizeMedium {
    font-size: 14px;
    height: 36px;
  }

  &.MuiButton-sizeSmall {
    font-size: 13px;
    height: 30px;
  }

  //contained variant

  &.MuiButton-contained {
    box-shadow: none;
  }

  &:not(:disabled).MuiButton-containedInfo {
    background: ${colors.primary.main};
  }

  &:not(:disabled).MuiButton-containedPrimary {
    background: ${colors.primary.main};
  }

  &:hover.MuiButton-containedInfo {
    background: ${colors.sidebar.itemSelected};
  }

  &:hover.MuiButton-containedPrimary {
    background: ${colors.sidebar.itemSelected};
  }

  //outlined variant

  &:not(:disabled).MuiButton-outlinedInfo {
    color: ${colors.primary.main};
    border-color: rgba(7, 114, 229, 0.5);
  }

  &:not(:disabled).MuiButton-outlinedPrimary {
    color: ${colors.primary.main};
    border-color: rgba(7, 114, 229, 0.5);
  }

  &:hover.MuiButton-outlinedInfo {
    background: ${colors.tint.primary.subtle};
  }

  &:hover.MuiButton-outlinedPrimary {
    background: ${colors.tint.primary.subtle};
  }

  //text variant
  &:not(:disabled).MuiButton-textInfo {
    color: ${colors.primary.main};
  }

  &:not(:disabled).MuiButton-textPrimary {
    color: ${colors.primary.main};
  }

  &:hover.MuiButton-textInfo {
    background: ${colors.tint.primary.subtle};
  }

  &:hover.MuiButton-textPrimary {
    background: ${colors.tint.primary.subtle};
  }
`;

export const CancelButton = Button;

export const PrimaryButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary',
})``;

export const SecondaryButton = styled(Button).attrs({
  variant: 'outlined',
  color: 'primary',
})``;

export const TextButton = styled(Button).attrs({
  variant: 'text',
  color: 'primary',
})``;

export const DangerButton = styled(Button).attrs({
  variant: 'contained',
  color: 'error',
})``;

export const IconButton = styled(MuiIconButton)``;
